import type { FeedPageMethods, ScreenLayout } from "@observe-tech/utils";
import { defaultScreenLayoutValues } from "./constants";
import { isFeedingScreen } from "./screenType";

const defaultFeedScreenData = defaultScreenLayoutValues.feedScreenData;

export const createFeedOperations = (
  findScreenLayout: (screenId: number) => ScreenLayout,
  setScreenLayout: (screenId: number, layout: ScreenLayout) => ScreenLayout,
) => {
  const getFeedData: FeedPageMethods["getFeedData"] = async (screenId) => {
    const layout = findScreenLayout(screenId);
    if (!isFeedingScreen(layout.screenType)) {
      return {
        sites: {
          siteIds: [],
        },
        columns: [],
        copilotColumns: [],
        filters: [],
      };
    }
    const feedData = layout.feedScreenData ?? defaultFeedScreenData;
    return {
      sites: feedData.sites,
      columns: feedData.columns,
      copilotColumns: feedData.copilotColumns,
      filters: feedData.filters,
    };
  };

  const updateFeedSites: FeedPageMethods["updateFeedSites"] = (
    screenId,
    sites,
  ) => {
    const layout = findScreenLayout(screenId);
    if (isFeedingScreen(layout.screenType)) {
      if (!layout.feedScreenData) {
        layout.feedScreenData = structuredClone(defaultFeedScreenData);
      }
      layout.feedScreenData.sites = sites;
      setScreenLayout(screenId, layout);
    }
  };

  const updateFeedColumns: FeedPageMethods["updateFeedColumns"] = (
    screenId,
    columns,
  ) => {
    const layout = findScreenLayout(screenId);
    if (isFeedingScreen(layout.screenType)) {
      if (!layout.feedScreenData) {
        layout.feedScreenData = structuredClone(defaultFeedScreenData);
      }
      layout.feedScreenData.columns = columns;
      setScreenLayout(screenId, layout);
    }
  };

  const updateCopilotFeedColumns: FeedPageMethods["updateCopilotFeedColumns"] =
    (screenId, columns) => {
      const layout = findScreenLayout(screenId);
      if (isFeedingScreen(layout.screenType)) {
        if (!layout.feedScreenData) {
          layout.feedScreenData = structuredClone(defaultFeedScreenData);
        }
        layout.feedScreenData.copilotColumns = columns;
        setScreenLayout(screenId, layout);
      }
    };

  const updateFeedFilters: FeedPageMethods["updateFeedFilters"] = (
    screenId,
    filters,
  ) => {
    const layout = findScreenLayout(screenId);
    if (isFeedingScreen(layout.screenType)) {
      if (!layout.feedScreenData) {
        layout.feedScreenData = structuredClone(defaultFeedScreenData);
      }
      layout.feedScreenData.filters = filters;
      setScreenLayout(screenId, layout);
    }
  };

  return {
    getFeedData,
    updateFeedSites,
    updateFeedColumns,
    updateCopilotFeedColumns,
    updateFeedFilters,
  };
};
